export default __webpack_public_path__ + "static/media/Rama_Logo_Color-01.7d62e825.png";